import { useMemo } from 'react';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';

import { themeConfig } from '../../config/material-theme.config';
import { createThemeGlobalStyles } from '../../theme/global-styles';
import { createThemeOptions } from '../../theme/theme-options';

import { ThemeOverrideProviderProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const ThemeOverrideProvider: React.FC<ThemeOverrideProviderProps> = (
  props
) => {
  const { settings, userThemeOptions, children } = props;

  // =============== HOOKS
  const theme = useMemo(() => {
    // Pass merged ThemeOptions (of core and user) to createTheme function
    let config = createTheme(
      createThemeOptions({ settings, overrideMode: 'light', userThemeOptions })
    );
    // Set responsive font sizes to true
    if (themeConfig.responsiveFontSizes) {
      config = responsiveFontSizes(config);
    }

    return config;
  }, [settings, userThemeOptions]);

  // =============== VIEWS
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <GlobalStyles styles={() => createThemeGlobalStyles(theme) as any} />
      {children}
    </ThemeProvider>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default ThemeOverrideProvider;
